import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwapCallsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swap_calls"}/>
}
